import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Particles from "./Particles";

export default function Chapter9Finale({ config }) {
  const [clicks, setClicks] = useState(0);
  const [secret, setSecret] = useState(false);

  const onDateClick = () => {
    const next = clicks + 1;
    setClicks(next);
    if (next >= 5) {
      setSecret(true);
      setClicks(0);
    }
  };

  return (
    <section
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-deep-black px-6 py-32 text-center"
      data-testid="chapter-9"
    >
      <Particles color="187, 166, 128" count={50} />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(187,166,128,0.10),transparent_65%)]" />

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 max-w-4xl font-serif text-4xl font-light leading-[1.15] tracking-tight text-ivory md:text-7xl"
      >
        {config.finale.line}
      </motion.h2>

      <div className="relative z-10 mt-16">
        <p className="text-xs uppercase tracking-[0.5em] text-ivory/50">Nos vemos el</p>
        <button
          data-testid="finale-date"
          data-cursor="hover"
          onClick={onDateClick}
          title="Nuestro día"
          className="mt-5 font-serif text-5xl font-light tracking-tight shimmer-text md:text-8xl"
        >
          {config.weddingDateLabel}
        </button>
        {clicks > 0 && clicks < 5 && (
          <p className="mt-4 text-[10px] uppercase tracking-[0.3em] text-gold/40">
            {"\u2022 ".repeat(clicks).trim()}
          </p>
        )}
      </div>

      <p className="relative z-10 mt-20 font-serif text-xl italic text-gold/80">
        {config.couple.partnerOne} &amp; {config.couple.partnerTwo}
      </p>
      <p className="relative z-10 mt-2 text-[10px] uppercase tracking-[0.4em] text-ivory/30">
        {config.couple.hashtag}
      </p>

      <AnimatePresence>
        {secret && (
          <motion.div
            data-testid="easter-egg-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSecret(false)}
            className="fixed inset-0 z-[96] flex items-center justify-center bg-deep-black/95 p-6 backdrop-blur-lg"
          >
            <motion.div
              initial={{ scale: 0.9, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="max-w-lg rounded-2xl border border-gold/30 bg-charcoal p-12 text-center"
            >
              <p className="mb-4 text-xs uppercase tracking-[0.4em] text-gold">Una nota secreta</p>
              <p className="font-serif text-2xl font-light italic leading-relaxed text-ivory md:text-3xl">
                {config.finale.secret}
              </p>
              <button
                onClick={() => setSecret(false)}
                className="mt-8 text-xs uppercase tracking-[0.3em] text-gold hover:text-ivory"
              >
                Cerrar
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
